<div class="individual-relationship-pob">
  <!-- your flag span -->
  <span class="flag" [class]="countryFlag"></span>

  <!-- wrap your two lines in a “column” -->
  <div class="text-col">
    <div class="font-weight-bold line-height-16">{{ birthCity }}</div>
    <div class="font-weight-normal line-height-16">{{ birthCountry | country }}</div>
  </div>
</div>
